import { BaseDto } from './base.dto';

export class PosDeviceTypeDto extends BaseDto {
  name: string;
}
